const preservedProtocols = ['mailto:', 'tel:'];

const DUMMY_DOMAIN = 'http://foo.bar';
/**
 * Rewrites a URL to ensure it is relative to the current page.
 */
export const rewriteUrl = (url: string, currentParentPath: string): string => {
  if (url.startsWith('ipenportal://')) {
    // ipenportal:// links are absolute paths to the ipen-portal, so we use this to route via router-dom
    return url.slice(13);
  }

  // The expression matches strings that satisfy any of these conditions:
  // 1. Starts and ends with characters that aren't `/` or `.` (e.g. "page")
  // 2. Ends with a / followed by characters without dots (e.g. "path/page", or "foo/")
  // 3. Ends with .htm or .html (e.g. "page.html")
  const isPageUrl = /(^[^/.]+|\/[^.]*|\.html?)$/i.exec(url);

  if (
    // mailto or tel
    preservedProtocols.some(protocol => url.startsWith(protocol))
    // or absolute urls
    || url.startsWith('http')
    // or its not a link to a page
    || !isPageUrl
  ) {
    return url;
  }

  // rewrite links of the iframe relative to the current locations path (the one from the window)
  let newParentPath = currentParentPath;
  if (newParentPath.endsWith('/')) {
    // remove trailing slash from the parent path
    newParentPath = newParentPath.slice(0, -1);
  }
  if (!url.startsWith('/')) {
    // now add a leading slash if the url does not start with one
    newParentPath += '/';
  }
  const newUrl = new URL(newParentPath + url, DUMMY_DOMAIN);
  if (!newUrl.pathname.endsWith('/')) {
    // add a trailing slash if the url does not end with one
    newUrl.pathname += '/';
  }
  return newUrl.href.replace(DUMMY_DOMAIN, '');
};
